import React from "react";
import { Search, X, RotateCcw } from "lucide-react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import "./product-lookup.css";

export const ProductQuickSearch = ({ query, brand, category, brands, categories, noBrandCount = 0, onChange, onReset, active, count, loading, error, onReload }) => (
  <section className="product-quick-search" data-testid="product-quick-search">
    <div className="product-search-scope" data-testid="product-search-scope">Поиск · опубликованные товары в наличии</div>
    <div className="product-search-controls">
      <div className="product-query-field">
        <Search size={16} aria-hidden="true" />
        <Input data-testid="product-quick-search-input" aria-label="Поиск по SKU, фабричному артикулу, названию, бренду или категории"
          maxLength={200} value={query} onChange={e => onChange("query", e.target.value)}
          placeholder="SKU, фабричный артикул, название…" />
        {!!query && <Button type="button" variant="ghost" size="icon" data-testid="product-search-clear-query"
          title="Очистить поиск" aria-label="Очистить поиск" onClick={() => onChange("query", "")}><X size={16} /></Button>}
      </div>
      <select data-testid="product-quick-brand-filter" aria-label="Бренд" value={brand} onChange={e => onChange("brand", e.target.value)}>
        <option value="">Все бренды</option>
        <option value="__no_brand__" data-testid="product-quick-brand-none">
          Без бренда{noBrandCount ? ` (${noBrandCount})` : ""}
        </option>
        {brand && brand !== "__no_brand__" && !brands.includes(brand) && <option value={brand}>{brand}</option>}
        {brands.map(b => <option key={b} value={b}>{b}</option>)}
      </select>
      <select data-testid="product-quick-category-filter" aria-label="Категория" value={category} onChange={e => onChange("category", e.target.value)}>
        <option value="">Все категории</option>
        {category && !categories.includes(category) && <option value={category}>{category}</option>}
        {categories.map(c => <option key={c} value={c}>{c}</option>)}
      </select>
      <Button type="button" variant="outline" data-testid="product-search-reset" disabled={!query && !brand && !category} onClick={onReset}>
        <RotateCcw size={14} /> Сбросить
      </Button>
    </div>
    {active && <div role="status" aria-live="polite" className="product-search-result-count" data-testid="product-search-result-count">
      {loading ? "Поиск…" : error ? "Товары не загружены" : `Найдено: ${count}`}
    </div>}
    {error && active && <div role="alert" className="product-search-error" data-testid="product-search-error">{error}
      <Button variant="outline" size="sm" data-testid="product-search-retry" onClick={onReload}>Повторить</Button>
    </div>}
  </section>
);